import { get } from '../Http';

export const getStores = async () => {
    try {
        const queryParams = {
            filters: JSON.stringify({ status: 1 })
        };
        const response = await get(`${process.env.EXTENDED_URL}store`, queryParams);
        return response.data;
    } catch (error) {
        console.error('Error fetching stores:', error);
        throw error;
    }
};
